export const headerHeight = 80;
export const sectionNavHeight = 68;
